import { TaskStatus } from './collector-task.model';

export interface DcEventConfigSource {
  dcType: string;
  dcSubtype: string;
}

export interface CollectionEvent {
  _id?: string;
  code: string;
  duration: number | null;
  critical: number | null;
  collectorAuthId: string | null;
  dcTypeOverride?: string | null;
  configSource?: DcEventConfigSource | null;
  status?: TaskStatus | null;
}

export interface DcRoster {
  _id?: string;
  gameId: string;
  billingMonth: string;
  dcDate: string;
  etcDate: string;
  etcTime: string;
  dcTime: string;
  region: string;
  dcType: string;
  dcSubtype: string;
  collectionEvents: CollectionEvent[];
}

export interface DcRosterWarning {
  code: string;
  message: string;
}

export type DcRosterSaveResponse = DcRoster & {
  warnings?: DcRosterWarning[];
};

export const DC_REGIONS = [
  { value: 'EU', label: 'Europe' },
  { value: 'NA', label: 'North America' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'AU', label: 'Australia' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'AS', label: 'Asia' }
] as const;

export interface DcSubtypeConfig {
  subType: string;
  description: string;
  collectionEvents: DcSubtypeCollectionEventConfig[];
}

export interface DcSubtypeCollectionEventConfig {
  code: string;
  eventGrade: number | null;
  effort: number | null;
  collectionType: string | null;
}

export interface DcTypeConfig {
  dcType: string;
  subTypes: DcSubtypeConfig[];
}
